.header {
  min-height: var(--logo-box-height);
  max-height: var(--logo-box-height);
  display: flex;
  align-items: center;
  gap: 34px;
}
.stepsContainer {
  display: flex;
  flex: 1;
  align-items: center;
  width: 0;
  overflow: hidden;
}
.stepItem {
  display: flex;
  font-size: var(--fs-small);
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
}
.stepItem.stepNext {
  filter: grayscale(100%);
  opacity: 0.4;
}
.stepNumber {
  min-width: 26px;
  width: 26px;
  height: 26px;
  margin-right: 8px;
  font-weight: normal;
  border-radius: 50%;
  display: flex;
  text-align: center;
  align-content: center;
  color: var(--primary-enabled-text);
}
.stepPrev > .stepNumber {
  background: #016719;
}
.stepActive > .stepNumber {
  background: var(--primary-enabled);
  color: var(--primary-enabled-text);
}
.stepNext > .stepNumber {
  border: 1px solid black;
  color: black;
}
.stepIcon {
  align-self: center;
  margin: auto;
  position: relative;
}
.spacer {
  background: var(--static-divider-standard);
  flex: 1;
  height: 1px;
  margin: 0 10px;
}
.arrow {
  margin: 0 -0.5rem;
  position: relative;
  top: 1px;
}
.actionButtons {
  display: flex;
  gap: 8px;
}
